import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useLoanDataFieldSelector, useLookup } from '@frontend/pricing-search';
import { get } from 'lodash';
import { PATH_SEARCH_RESULTS } from '../../../route/constants';
import Session, { IS_BUYSIDE, IS_LOCK_EXTENSION } from '../../services/Session';

export const useIsHistoricalPricing = () => {
  const [isOpen, setOpen] = useState(false);
  const [showMessage, setShowMessage] = useState(true);
  const { effectiveDate = '' } = useLoanDataFieldSelector(
    'relockRequest',
    {}
  ) as any;
  const { tabId } = useSelector(({ landing }) => landing);
  const clientsettings = useLookup('clientSettings', '');

  useEffect(() => {
    const momentEffectiveDate = moment.tz(
      effectiveDate,
      ['MM/DD/YYYY hh:mm A', 'YYYY-MM-DDTHH:mm:ss a z'],
      'America/New_York',
    );
    setOpen(
      tabId === PATH_SEARCH_RESULTS &&
        !!effectiveDate &&
        momentEffectiveDate.isBefore(moment()),
    );
    if (
      Session.get(IS_BUYSIDE) === true &&
      Session.get(IS_LOCK_EXTENSION) === false &&
      get(clientsettings, '[0].options.isBuySideHistorical') === false
    ) {
      setShowMessage(false);
    }
  }, [effectiveDate, tabId, showMessage]);

  return {
    isOpen,
    setOpen,
    showMessage,
    effectiveDate,
  };
};
